/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { connect } from 'react-redux'
import { companyActions } from '../_actions'
import BulkUploadComponent from '../components/BulkUploadComponent'
// eslint-disable-next-line react/prop-types
function BulkUploadContainer({ getFileUploadLogs, deleteFileLogById, fileUploadLog, fileUploadLogCount, fileLogDeleteResponse, clearFileLog }) {
  return (
    <div className="p-grid pageWrapper">
      <BulkUploadComponent getFileUploadLogs={getFileUploadLogs} deleteFileLogById={deleteFileLogById} fileUploadLog={fileUploadLog} fileUploadLogCount={fileUploadLogCount} fileLogDeleteResponse={fileLogDeleteResponse} clearFileLog={clearFileLog} />
    </div>
  )
}
const mapStateToProps = state => {
  return {
    fileUploadLog: state.company.fileUploadLog,
    fileUploadLogCount: state.company.fileUploadLogCount,
    fileLogDeleteResponse: state.company.fileLogDeleteResponse
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getFileUploadLogs: (start, pageSize) => dispatch(companyActions.getFileUploadLogs(start, pageSize)),
    deleteFileLogById: (id) => dispatch(companyActions.deleteFileLogById(id)),
    clearFileLog: () => dispatch(companyActions.clearFileLog())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkUploadContainer)
